

export function SocialLinks() {
    return (
        <div className="flex flex-col items-center gap-4">
            <p className="text-xs font-bold uppercase tracking-[0.3em] text-main">
                Valóranos en
            </p>
            <div className="flex items-center gap-4">
                <a
                    href="https://www.tripadvisor.es/Restaurant_Review-g147271-d32717448-Reviews-El_Gaban-Havana_Ciudad_de_la_Habana_Province_Cuba.html"
                    className="flex items-center justify-center w-14 h-14 rounded-full transition-all duration-300 hover:scale-110"
                    aria-label="TripAdvisor"
                >
                    <img
                        src="/tripAdvisorLogo.svg"
                        alt="TripAdvisor"
                        className="w-full h-full object-contain"
                    />
                </a>
                <a
                    href="https://www.google.com/search?sca_esv=6da2c71a879288c4&hl=es-CU&sxsrf=ANbL-n5QN7YFpYW-ZoIQn-SzRFcFoQ4itw:1771349610373&q=opiniones+de+el+gab%C3%A1n&uds=ALYpb_lH_4xvWFoNgmfTwU0T7BCmz0QfO4Hqt8Ked5QRbi3uoKSJH6maMYtxHoXW-s__wFQwbA3VqP7psEjm4oqbHxZR1muveAx2jCsuidMIFSL68pnsT-Q4Z9L-N-bA8kYGBnrZS5W9cesoJqeELunR-5E15_9TC0tACY6Lr_rP8-M8OkvFGdI-OA0euCWvyqOLe5pvERp3PO5hOyV894zRojQEwPzWyDK_apAcpfJivWEdQJMNpjtmnpUfhlSEdFP9i8daDHodxiGbrv99zVujnGXzJ732mhtJKLqxohGr2NWkPOMK6BZYSoiDp55c5t8e7hdFDDttPnsgpU_DNFxkYE6_llP1MqMcwq3B2Zq8ppsl0PKxCRRiCfEK_TwWtKtH2GLBcNUv3A9kN3PxREzOSymQlNrryfKkYLHl6q-gmeTPBb3HRLY&si=AL3DRZEsmMGCryMMFSHJ3StBhOdZ2-6yYkXd_doETEE1OR-qOXKSXBH9YHBuIt38Q6GT3TTFZi3ixpoARtunTUqO-PJW7eWBjCYRwMGQwAtetOQxJ2f-HzzSKEIYya_DUbdlCIp5QQWE&sa=X&ved=2ahUKEwjfgLLCh-GSAxVHkyYFHW7-C5kQk8gLegQIHxAB&ictx=1&biw=393&bih=773&dpr=3#"
                    className="flex items-center justify-center w-14 h-14 rounded-full transition-all duration-300 hover:scale-110"
                    aria-label="Google Reviews"
                >
                    <img
                        src="/googleLogo.svg"
                        alt="Google"
                        className="w-full h-full object-contain"
                    />
                </a>
            </div>
        </div>
    )
}
